import drentheShape from '@/assets/drenthe_geojson.json';
import gemeentenShape from '@/assets/gemeenten_drenthe_geojson.json';

const storeState = {
  drentheShape,
  gemeentenShape,
};

const getters = {
  getGemeentenValues: (state) => {
    const values = [];
    state.gemeentenShape.features.forEach((feature) => {
      values.push({
        code: feature.properties.code,
        name: feature.properties.gemeentena,
      });
    });
    values.sort((a, b) => a.name.localeCompare(b.name));
    return values;
  },
};


export default {
  namespaced: true,
  state: storeState,
  getters,
};
